import React, { useState } from "react";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";

import ButtonComponent from "../Button";

function ModalComponent() {
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  return (
    <>
      <Button variant="primary" onClick={handleShow}>
        Launch demo modal
      </Button>

      <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Modal heading</Modal.Title>
        </Modal.Header>
        <Modal.Body>Woohoo, you're reading this text in a modal!</Modal.Body>
        <Modal.Footer>
          <ButtonComponent
            size="10rem"
            bgColor="var(--cinza-secundario)"
            textColor="var(--branco)"
            action={handleClose}
          >
            Cancel
          </ButtonComponent>
          <ButtonComponent
            size="10rem"
            bgColor="var(--verde-secundario)"
            textColor="var(--branco)"
            action={handleClose}
          >
            Success
          </ButtonComponent>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default ModalComponent;
